<template>
    <FAQ :tab="1"></FAQ>
</template>


<script>
import FAQ from '../users/FAQ.vue';

export default {
    name: "FAQSections",
    components: {
        FAQ,
    },
    data: function () {
        return {
        };
    },
    computed: {
    },
    methods: {
    },
};
</script>


<style lang="scss" scoped>
</style>
